import clsx from "clsx";
import Image from 'next/image';
import Link from "next/link";

import Authors from "@components/Authors";
import CategoryTokens from "@components/CategoryTokens";
import FileDownloadButtons from "@components/FileDownloadButtons";
import SecondaryButton from "@components/SecondaryButton";
import Share from "@components/Share";
import getHref from "@lib/routes";

const GlossaryEntryHeader = ({
	breadcrumb = null,
	heading,
	summary,
	showSummary = false,
	categories = [],
	date = null,
	heroImage,
	heroImageBlur,
	authors = [],
	url = null,
	downloadableFiles = [],
	shareAlignment = "left",
	overlayTextTheme = "dark",
	target,
  secondaryTarget,
	legacyButtonBackgroundColor,
	buttonTextColor,
}) => {
	const breadcrumbHref = getHref(breadcrumb);

	const hasCategories = !!categories && categories.length > 0;

	return (
		<div
    className={clsx("EntryHeader", "mb-10", "w-full", "relative", "pt-28", "pb-0", "bg-purple-gray-02")}
		>
			<div className={clsx("EntryHeader__wrapper relative")}>
				<div
					className={clsx(
						"EntryHeader__columns",
						"max-w-screen-xl mx-auto",
						"flex flex-col lg:flex-row lg:px-7.5",
						"pt-0 pb-10"
					)}
				>
					<div
						className={clsx(
							"EntryHeader__main",
							"mb-0 px-7.5 lg:px-0 lg:w-2/3"
						)}
					>
						{!!breadcrumb && (
							<div className={clsx("EntryHeader__breadcrumb", "mb-7.5")}>
								<Link href={breadcrumbHref} className={clsx("hover-underline")}>
									<span className={clsx("pb-2")}>{breadcrumb.title}</span>
								</Link>
							</div>
						)}
						<h1
							className={clsx(
								"EntryHeader__heading",
								"text-2xl md:text-3xl lg:text-4xl 3xl:text-5xl", "text-purple-01",
								"max-w-4xl",
								{
									"mb-3": summary && showSummary,
								}
							)}
						>
							{heading}
						</h1>

						{summary && showSummary && <p>{summary}</p>}

						{!!target && !!target.url && (
							<div
								className={clsx(
									"EntryHeader__secondaryButton",
									"max-w-3xl",
									"mt-10 mx-0"
								)}
							>
								<SecondaryButton
									target={target}
									legacyBackgroundColor={legacyButtonBackgroundColor}
									textColor={buttonTextColor}
								/>

                	{downloadableFiles.length > 0 && (
							<div className={clsx("EntryHeader__downloadableFiles mt-4")}>
								<FileDownloadButtons files={downloadableFiles} />{" "}
							</div>
						)}
							</div>
						)}

            	{!!secondaryTarget && !!secondaryTarget.url && (
							<div
								className={clsx(
									"EntryHeader__secondaryButton",
									"max-w-3xl",
									"mt-4 mx-0"
								)}
							>
								<SecondaryButton
									target={secondaryTarget}
									 textColor={"#000"}
                  legacyBackgroundColor={"#B9BAED"}
                  borderColor={"#B9BAED"}
                  hoverBackgroundColor={"#000"}
                  hoverTextColor={"#fff"}
								/>
							</div>
						)}

						{hasCategories && (
							<div className={clsx("EntryHeader__categoryTokens", "mt-7.5")}>
								<CategoryTokens categories={categories} />
							</div>
						)}
						<div>
							{!!authors && (
								<div className={clsx("EntryHeader__authors")}>
									<Authors authors={authors} />
								</div>
							)}
							{!!date && (
								<div
									className={clsx(
										"EntryHeader__categoryTokens",
										"mt-7.5 text-xs"
									)}
								>
									{date}
								</div>
							)}
						</div>
					</div>
				</div>
			</div>
		</div>
	);
};

export default GlossaryEntryHeader;
